module.exports = __webpack_public_path__ + "static/media/donate.9c9a0277.jpg";